// src/utils/catalogSlang.js
//
// ── Design decisions ──────────────────────────────────────────────────────────
// Vocabulario de encomienda salvadoreña como DATOS, no como código. Este archivo
// se va a editar seguido por gente que no programa, así que:
//   · Tres constantes planas. Una entrada por línea. Sin lógica.
//   · Cada entrada de JERGA lleva un comentario de procedencia al final de la
//     línea (quién lo confirmó y cuándo) — así nadie borra una palabra "rara"
//     sin saber de dónde salió.
//   · Todo en minúsculas y SIN tildes salvo la ñ (la búsqueda normaliza igual).
//
// ── Cómo agregar una palabra ──────────────────────────────────────────────────
//   1. JERGA: agregá una línea  'palabra': 'término formal',  // procedencia
//      La clave es la palabra tal como la escribe el gestor (singular). El
//      valor es la palabra que SÍ aparece en el catálogo DGA. Puede tener
//      varias palabras ('ropa interior').
//   2. MARCADORES_TIER: agregá el texto que escribe el gestor dentro de
//      `patrones` del tier que corresponda. Los patrones más largos van primero.
//   3. STOPWORDS: palabras que no aportan nada a la búsqueda ('de', 'para').
//   Guardá el archivo y listo — los tests de catalogSearch cubren el resto.
// ─────────────────────────────────────────────────────────────────────────────

// Jerga → término formal. Cada expansión se REPORTA al gestor como una
// interpretación visible (chip ámbar), nunca se aplica en silencio.
export const JERGA = {
  yinas: 'sandalias',            // Salvadoran — confirmed Milton Aug 2026
  yina: 'sandalias',             // singular de yinas — eval samples Aug 2026
  pans: 'pantalón',              // Salvadoran — confirmed Milton Aug 2026
  pantis: 'pantalón',            // Salvadoran — confirmed Milton Aug 2026
  chumpa: 'chaqueta',            // Salvadoran — confirmed Milton Aug 2026
  blumer: 'ropa interior',       // Salvadoran (blúmer) — confirmed Milton Aug 2026
  pestañoles: 'pestañol',        // plural irregular — eval samples Aug 2026
  yines: 'jeans',                // Salvadoran — confirmed Milton Aug 2026
  tennis: 'tenis',               // variante ortográfica — eval samples Aug 2026
  tenis: 'tenis',                // evita singularizar a "teni" — eval samples Aug 2026
};

// Marcadores de tier de marca. `patrones`: lo que escribe el gestor (los más
// largos primero para que "marca de prestigio" gane sobre "marca"). `frases`:
// lo que dice el catálogo DGA, para el empuje de ranking. `etiqueta`: lo que
// se muestra en el chip de interpretación.
export const MARCADORES_TIER = {
  otras: {
    etiqueta: 'otras marcas',
    patrones: ['otras marcas', 'otra marca', 'o/m', 'o.m', 'om'],
    frases: ['OTRAS MARCAS'],
  },
  prestigio: {
    etiqueta: 'marca de prestigio',
    patrones: ['marca de prestigio', 'marca prestigio', 'de prestigio', 'prestigio', 'm/p', 'm.p'],
    frases: ['MARCA DE PRESTIGIO', 'PRESTIGIO'],
  },
  lujo: {
    etiqueta: 'lujo',
    patrones: ['de lujo', 'lujo'],
    frases: ['LUJO'],
  },
};

// Palabras vacías: se descartan antes de consultar el catálogo.
export const STOPWORDS = [
  'de', 'del', 'la', 'el', 'los', 'las', 'un', 'una', 'para', 'p/', 'con',
  'y', 'o', 'en', 'por', 'su',
  'par', 'pares',   // unidad de medida, no descripción — eval samples Aug 2026
];
